export enum MessageType {    
    FirstContact = 0,
    Reply = 1,
    Note = 2,
    Forward = 3
}